import {Nut_OneOff_Billing_ApplyQuotesCoupon} from 'nutshell-core/settings-constants';

import {getPlanToDisplay} from 'shells/billing/add-ons/helpers';

import {useGetSetting} from '../../../core/use-get-setting';
import {useGetAvailablePlans} from '../../../setup/billing/graphql/hooks/use-get-available-plans';

export function useGetShowQuotesPromo() {
    const {
        setting,
        isLoading: isSettingLoading,
        refetch: refetchSetting,
    } = useGetSetting({
        settingName: Nut_OneOff_Billing_ApplyQuotesCoupon.PENDING_COUPON_SETTING_KEY,
    });

    const hasPendingCoupon =
        Boolean(setting?.value) &&
        NutClientConfig.loggedInUserIsAdmin &&
        !NutClientConfig.hasQuotePlan;

    const {addOns, isLoading: isPlansLoading} = useGetAvailablePlans(!hasPendingCoupon);
    const quotesAddOn = addOns?.quotes;

    const planToDisplay = quotesAddOn
        ? getPlanToDisplay(quotesAddOn.plans, null, quotesAddOn.defaultCode)
        : null;

    const isCouponValid =
        isPlansLoading || !quotesAddOn
            ? true
            : planToDisplay?.coupon?.code ===
              Nut_OneOff_Billing_ApplyQuotesCoupon.COUPON_CODE_SETTING;

    return {
        shouldShow: hasPendingCoupon && isCouponValid,
        isLoading: isSettingLoading,
        refetchSetting,
    };
}
